import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _cloneDeep from "lodash/cloneDeep";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.array.filter.js";
import { EXPERIMENTS_METADATA_RENAME } from 'redux/actionTypes/experiments';
import fetchAPI from 'utils/http/fetchAPI';
import { metadataNameToKey } from 'utils/data-management/metadataUtils';
import endUserMessages from 'utils/endUserMessages';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import { loadBackendStatus } from '../backendStatus';
var renameMetadataTrack = function renameMetadataTrack(oldName, newName, experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var experiment, oldMetadataKey, newMetadataKey, newExperiment, _body;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              experiment = getState().experiments[experimentId];
              oldMetadataKey = metadataNameToKey(oldName);
              newMetadataKey = metadataNameToKey(newName);
              newExperiment = _cloneDeep(experiment);
              newExperiment.metadataKeys = newExperiment.metadataKeys.filter(function (key) {
                return key !== oldMetadataKey;
              });
              newExperiment.metadataKeys.push(newMetadataKey);
              _context.prev = 6;
              _body = {
                key: newMetadataKey
              };
              _context.next = 10;
              return fetchAPI("/v2/experiments/".concat(experimentId, "/metadataTracks/").concat(oldMetadataKey), {
                method: 'PATCH',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(_body)
              });
            case 10:
              dispatch({
                type: EXPERIMENTS_METADATA_RENAME,
                payload: {
                  oldKey: oldMetadataKey,
                  newKey: newMetadataKey,
                  experimentId: experimentId
                }
              });
              _context.next = 13;
              return dispatch(loadBackendStatus(experimentId));
            case 13:
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](6);
              pushNotificationMessage('error', endUserMessages.ERROR_SAVING);
            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 15]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default renameMetadataTrack;